// src/pages/PaymentSuccess.js
import { useLocation, useNavigate } from "react-router-dom";

const PaymentSuccess = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  if (!state) {
    return (
      <div className="p-4 text-center">
        <h2>Payment information not found</h2>
        <button
          onClick={() => navigate("/lead")}
          className="mt-4 px-4 py-2 bg-blue-600 text-white rounded"
        >
          Back to Leads
        </button>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto p-4 text-center">
      <div className="text-green-500 text-5xl mb-4">✓</div>
      <h2 className="text-2xl font-bold mb-2">Payment Successful!</h2>
      <p className="text-gray-600 mb-6">
        Your payment of ₹{state.amount} has been processed.
      </p>

      <div className="bg-white p-4 rounded-lg shadow-md text-left mb-6">
        <p>
          <span className="font-medium">Transaction ID:</span>{" "}
          {state.transactionId}
        </p>
        <p className="mt-2">
          <span className="font-medium">Lead ID:</span> {state.leadId}
        </p>
      </div>

      <button
        onClick={() => navigate("/lead")}
        className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
      >
        Back to Leads
      </button>
    </div>
  );
};

export default PaymentSuccess;
